import PulseLoader from "react-spinners/PulseLoader";
import MoonLoader from "react-spinners/MoonLoader";
import { createPortal } from "react-dom";

import { Wrapper } from "./Loading.style";
import { theme } from "styles/mui-config";

function LoadingCM({
  size = 10,
  color = theme.palette.primary.dark,
  isImg = false,
}) {
  if (isImg) {
    return <MoonLoader color={color} size={40} />;
  } else
    return createPortal(
      <Wrapper>
        <PulseLoader color={color} size={size} />
      </Wrapper>,
      document.getElementById("loading")
    );
}

export default LoadingCM;
